import React, {useEffect, useState} from "react";
import {
    AppBar,
    IconButton, Link,
    makeStyles,
    Menu,
    MenuItem, Switch,
    Toolbar,
    Typography
} from "@material-ui/core";
import {Link as RouterLink} from 'react-router-dom'
import {AccountCircle} from "@material-ui/icons";
import Brightness6Icon from '@material-ui/icons/Brightness6';
import {connect} from "react-redux";
import {USER_KEY} from "../helpers/TokenHelper";
import {logoutUserFromServer} from "../redux/login/AuthServerActions";

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    logo: {
        margin: theme.spacing(1, 2, 1),
        maxHeight: '42px'
    },
    link: {
        color: "white",
        textDecoration: 'none'
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    navbarActionContainer: {
        display: 'flex',
        alignItems: 'center',
        flex: 1,
        justifyContent: 'flex-end'

    }

}));
const NavBar = (props) => {
    const {
        logoutUser,
        handleThemeClick,
        theme
    } = props;
    const [username, setUsername] = useState('');
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    useEffect(() => {
        let user = JSON.parse(localStorage.getItem(USER_KEY));
        if (user) {
            setUsername(user.name);
            setIsLoggedIn(true);
        } else {
            setUsername('');
            setIsLoggedIn(false);
        }
    })

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = () => {
        logoutUser();
        handleClose();
    }

    const handleThemeChange = (e) => {
        handleThemeClick();
    }


    const classes = useStyles();

    return <AppBar position="static" color={theme === 'light' ? 'primary' : "transparent"}>
        <Toolbar>
            <Link
                component={RouterLink}
                to='/'>
                <img className={classes.logo} src={process.env.PUBLIC_URL + "/img/logo.png"} alt='logo'/>
            </Link>
            <Typography
                component={RouterLink}
                to='/'
                display='inline'
                className={classes.link}>
                Nexus Pickup
            </Typography>
            {
                isLoggedIn ?
                    <div className={classes.navbarActionContainer}>
                        <Switch
                            color='default'
                            icon={<Brightness6Icon/>}
                            checkedIcon={<Brightness6Icon/>}
                            onChange={handleThemeChange}
                            checked={theme === 'light'}/>
                        <div>
                            {`Welcome, ${username}`}
                        </div>
                        <div>
                            <IconButton
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={handleMenu}
                                color="inherit"
                            >
                                <AccountCircle/>
                            </IconButton>
                            <Menu
                                id="menu-appbar"
                                anchorEl={anchorEl}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={open}
                                onClose={handleClose}
                            >

                                <MenuItem onClick={handleLogout}>Logout</MenuItem>

                            </Menu>

                        </div>
                    </div>
                    : null
            }
        </Toolbar>
    </AppBar>;
}

const mapStateToProps = state => {
    return {
        auth: state.auth
    }
}

const mapDispatchToProps = dispatch => {
    return {
        logoutUser: () => logoutUserFromServer()
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps()
)(NavBar);
